import React, { useEffect, useState } from 'react';
import ModalStyled from '../ModalStyled/ModalStyled';
import { collection, doc, getDoc, getDocs, query, where } from 'firebase/firestore';
import { database } from '../../services/firebase';
import { Text, Title, WrapperText } from './styled';
import { formatReal, isEmptyObject } from '../../utils/objectManipulation';
import { Spacing } from '../Spacing/Spacing';
import { ButtonStyled } from '../ButtonStyled/ButtonStyled';
import { COLORS } from '../../constants/COLORS';
import AlertDialog from '../AlertDialog/AlertDialog';
import { changeEnterpriseStatus, saveEnterprisesAdmin } from '../../services/enterprisesAdmin';
import { PLANT_STATUS } from '../../constants/PLANT_STATUS';
import { deleteReservation, saveReservation } from '../../services/reservation';
import { InputAdornment, Typography } from '@mui/material';
import InputStyled from '../InputStyled/InputStyled';
import { getDataForm, isValidForm } from '../../utils/formController';
import { createProposal } from '../../services/proposal';
import { ALERT_TYPES } from '../../constants/ALERT_TYPES';
import { useSnackbar } from 'notistack';
import { COLLECTION } from '../../constants/COLLECTION';
import { dateToInput, dateToString } from '../../utils/date';
import { RESERVATION_STATUS } from '../../constants/RESERVATION_STATUS';
import { currentUser, getAdminById, getUserById } from '../../services/user';
import { USER_PERMISSION } from '../../constants/USER_PERMISSION';
import { getDatabase, getDataDocs } from '../../services/firestore';
import { clearNotification, sendEmail, sendPushNotification } from '../../services/notification';
import { useNavigate } from 'react-router-dom';

const ModalReservation = ({ setOpen, open, id, getReservations, isAdmin = false }) => {
  const [reservation, setReservation] = useState();
  const [enterprise, setEnterprise] = useState();
  const [isProposal, setIsProposal] = useState(false);
  const [openPlusTime, setOpenPlusTime] = useState(false);
  const [openDeleteReservation, setOpenDeleteReservation] = useState(false);
  const [openCloseDialogProposal, setOpenCloseDialogProposal] = useState(false);
  const [form, setForm] = useState();
  const [reservationUser, setReservationUser] = useState();
  const [formPlusTime, setFormPlusTime] = useState();
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const getReservation = async () => {
    if (!isEmptyObject(id)) {
      const data = await getDoc(doc(database, COLLECTION.RESERVATIONS, id));
      setReservation(data?.data());
      setFormPlusTime({ time: { value: dateToInput(data?.data()?.validDate) } });
    }
  };

  const getReservationUser = async () => {
    if (!isEmptyObject(reservation)) {
      console.log('Pietro', currentUser());
      const data = getDataDocs(
        await getDocs(query(collection(getDatabase(), COLLECTION.USERS), where('id', '==', reservation?.user)))
      );
      setReservationUser(data[0]);
    }
  };

  const getEnterprise = async () => {
    const data = await getDoc(doc(database, COLLECTION.ENTERPRISES, reservation?.enterprise));
    setEnterprise(data?.data());
  };

  const removerReservation = async () => {
    setIsLoading(true);
    const newEnterprise = changeEnterpriseStatus(
      PLANT_STATUS.AVAILABLE,
      enterprise,
      reservation?.square + reservation?.number
    );
    await saveEnterprisesAdmin(newEnterprise);
    await deleteReservation(reservation);
    if (isAdmin) {
      sendPushNotification(
        'A reserva foi removida: ' +
          enterprise?.name +
          ' | lote ' +
          reservation?.number +
          ' quadra ' +
          reservation?.square,
        '',
        reservation?.user,
        window.location.origin + '/reservas'
      );
    } else {
      enterprise.user.map(userId =>
        sendPushNotification(
          'A reserva foi removida: ' +
            enterprise?.name +
            ' | lote ' +
            reservation?.number +
            ' quadra ' +
            reservation?.square,
          '',
          userId,
          window.location.origin + '/admin/reservas'
        )
      );
    }
    setOpenDeleteReservation(false);
    setOpen(false);
    getReservations();
    navigate(currentUser()?.permission === USER_PERMISSION.ADMIN ? '../admin/reservas' : '../reservas');
    setIsLoading(false);
  };

  const sendProposal = async () => {
    setIsLoading(true);
    if (isValidForm(form, setForm)) {
      const newEnterprise = changeEnterpriseStatus(
        PLANT_STATUS.IN_PROPOSAL,
        enterprise,
        reservation?.square + reservation?.number
      );
      await saveEnterprisesAdmin(newEnterprise);
      await deleteReservation(reservation);
      const data = getDataForm(form);
      const newProposal = {
        clientName: reservation?.clientName,
        clientIdentification: reservation?.clientIdentification,
        clientPhone: reservation?.clientPhone,
        number: reservation?.number,
        square: reservation?.square,
        user: reservation?.user,
        userName: reservation?.userName,
        chat: [
          {
            message: 'R$' + data.price + ' - ' + data.description,
            sender: USER_PERMISSION.USER,
            date: new Date(),
            senderName: currentUser()?.name,
          },
        ],
        enterprise: enterprise?.id,
        enterpriseName: enterprise?.name,
      };
      const proId = (await createProposal(newProposal))[0]?.id;
      if (isAdmin) {
        const getUser = await getUserById(reservation?.user);
        sendEmail(
          getUser?.email,
          'Nova Proposta!',
          'Olá, ' + getUser?.name + '! Segue o link para acessar proposta.',
          window.location.origin + '/propostas/' + proId
        );
        sendPushNotification(
          'Nova Proposta: ' + enterprise?.name + ' | lote ' + reservation?.number + ' quadra ' + reservation?.square,
          'R$' + data.price + ' - ' + data.description,
          getUser?.id,
          window.location.origin + '/propostas/' + proId
        );
      } else {
        enterprise.user.map(async user => {
          const admin = await getAdminById(user);
          sendEmail(
            admin?.email,
            'Nova Proposta!',
            'Olá, ' + admin?.name + '! Segue o link para acessar proposta.',
            window.location.origin + '/admin/propostas/' + proId
          );
          sendPushNotification(
            'Nova Proposta: ' + enterprise?.name + ' | lote ' + reservation?.number + ' quadra ' + reservation?.square,
            'R$' + data.price + ' - ' + data.description,
            admin?.id,
            window.location.origin + '/admin/propostas/' + proId
          );
        });
      }
      getReservations();
      setOpenCloseDialogProposal(false);
      navigate(
        currentUser()?.permission === USER_PERMISSION.ADMIN ? '../admin/propostas/' + proId : '../propostas/' + proId
      );
      enqueueSnackbar('Proposta criada com sucesso.', { variant: ALERT_TYPES.SUCCESS });
    } else {
      setOpenCloseDialogProposal(false);
      enqueueSnackbar('Dados inválidos.', { variant: ALERT_TYPES.WARNING });
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getEnterprise();
    getReservationUser();
    clearNotification();
  }, [reservation]);

  useEffect(() => {
    getReservation();
  }, [id]);

  return (
    <>
      <AlertDialog
        open={openDeleteReservation}
        title={'Ops!'}
        text={'Deseja realmente excluir a reserva?'}
        handleClose={() => setOpenDeleteReservation(false)}
        actions={
          <>
            <ButtonStyled onClick={() => setOpenDeleteReservation(false)}>Cancelar</ButtonStyled>
            <ButtonStyled disabled={isLoading} onClick={() => removerReservation()}>
              Excluir
            </ButtonStyled>
          </>
        }
      />
      <AlertDialog
        open={openCloseDialogProposal}
        title={'Ops!'}
        text={'Deseja realmente enviar a proposta?'}
        handleClose={() => setOpenCloseDialogProposal(false)}
        actions={
          <>
            <ButtonStyled onClick={() => setOpenCloseDialogProposal(false)}>Cancelar</ButtonStyled>
            <ButtonStyled disabled={isLoading} onClick={() => sendProposal()}>
              Enviar
            </ButtonStyled>
          </>
        }
      />
      <ModalStyled
        setOpen={setOpen}
        open={open}
        onClose={() => {
          setForm({});
          setIsProposal(false);
          getReservations();
          navigate(currentUser()?.permission === USER_PERMISSION.ADMIN ? '../admin/reservas' : '../reservas');
        }}
        title={
          isEmptyObject(reservation)
            ? 'Reserva não encontrada!'
            : 'Reserva: ' + reservation?.enterpriseName + ' | ' + reservation?.square + ' - ' + reservation?.number
        }
      >
        <ModalStyled setOpen={setOpenPlusTime} open={openPlusTime} title={'Aumentar Expiração'}>
          <InputStyled
            controller={{ form: formPlusTime, setForm: setFormPlusTime }}
            name={'time'}
            label={'Nova data de Expiração'}
            type={'datetime-local'}
            inputProps={{ min: dateToInput(reservation?.validDate), max: '3500-09-27 00:00' }}
          />
          <Spacing jc={'flex-end'} fd={'row'} margin={'16px 0 0 0'}>
            <ButtonStyled
              margin={'0 8px 0 0'}
              onClick={async () => {
                if (isValidForm(formPlusTime, setFormPlusTime)) {
                  const newReservation = {
                    ...reservation,
                    validDate: new Date(formPlusTime?.time.value),
                  };
                  await saveReservation(newReservation);
                  setOpenPlusTime(false);
                  await getReservation();
                  enqueueSnackbar('Alterado com sucesso', { variant: ALERT_TYPES.SUCCESS });
                } else {
                  enqueueSnackbar('Dados inválidos.', { variant: ALERT_TYPES.WARNING });
                }
              }}
              variant="contained"
              component="span"
              bg={COLORS.GREEN_LIGHT}
            >
              Aumentar Validade
            </ButtonStyled>
          </Spacing>
        </ModalStyled>
        {!isEmptyObject(reservation) && (
          <>
            <Title>Informações</Title>
            <WrapperText>
              <Text>Status: </Text>
              <Text>{reservation?.status === RESERVATION_STATUS.RESERVED ? 'Reservado' : 'Expirado'}</Text>
            </WrapperText>
            <WrapperText>
              <Text>Data de expiração: </Text>
              <Text>{dateToString(reservation?.validDate)}</Text>
            </WrapperText>
            <WrapperText>
              <Text>Data de criação: </Text>
              <Text>{dateToString(reservation?.createdAt)}</Text>
            </WrapperText>
            <WrapperText>
              <Text>Empreendimento: </Text>
              <Text>{reservation?.enterpriseName}</Text>
            </WrapperText>
            <WrapperText>
              <Text>Quadra: </Text>
              <Text>{reservation?.square}</Text>
            </WrapperText>
            <WrapperText>
              <Text>Número: </Text>
              <Text>{reservation?.number}</Text>
            </WrapperText>
            <Title>Cliente</Title>
            <WrapperText>
              <Text>Nome: </Text>
              <Text>{reservation?.clientName}</Text>
            </WrapperText>
            <WrapperText>
              <Text>Telefone: </Text>
              <Text>{reservation?.clientPhone}</Text>
            </WrapperText>
            <WrapperText>
              <Text>Identificação: </Text>
              <Text>{reservation?.clientIdentification}</Text>
            </WrapperText>
            {isAdmin && (
              <>
                <Title>Corretor</Title>
                <WrapperText>
                  <Text>Nome: </Text>
                  <Text>{reservation?.userName}</Text>
                </WrapperText>
                <WrapperText>
                  <Text>CRECI: </Text>
                  <Text>{reservationUser?.creci}</Text>
                </WrapperText>
                <WrapperText>
                  <Text>Telefone: </Text>
                  <Text>
                    {reservationUser?.phone
                      .toString()
                      .substring(3, reservationUser?.phone.length)
                      .replace(/\D/g, '')
                      .replace(/(\d{2})(\d)/, '($1) $2')
                      .replace(/(\d{5})(\d{4})/, '$1-$2')}
                  </Text>
                </WrapperText>
              </>
            )}
            {isProposal && (
              <>
                <Typography align={'left'} sx={{ width: '100%', margin: '16px 0 8px 0' }}>
                  Proposta
                </Typography>
                <InputStyled
                  startAdornment={<InputAdornment position="start">R$</InputAdornment>}
                  mask={value => value && formatReal(parseInt(value.toString().replace(/\D+/g, '')))}
                  controller={{ form, setForm }}
                  name={'price'}
                  label={'Valor'}
                  type={'text'}
                />
                <InputStyled
                  multiline
                  controller={{ form, setForm }}
                  name={'description'}
                  label={'Nota de negociação'}
                  type={'text'}
                />
              </>
            )}
            <Spacing jc={'flex-end'} fd={'row'} margin={'16px 0 0 0'}>
              {reservation?.status !== RESERVATION_STATUS.EXPIRED ? (
                isProposal ? (
                  <ButtonStyled
                    margin={'0 8px 0 0'}
                    onClick={() => setOpenCloseDialogProposal(true)}
                    variant="contained"
                    component="span"
                    bg={COLORS.GREEN_LIGHT}
                  >
                    Enviar Proposta
                  </ButtonStyled>
                ) : (
                  <>
                    <ButtonStyled
                      margin={'0 8px 0 0'}
                      onClick={() => setIsProposal(true)}
                      variant="contained"
                      component="span"
                      bg={COLORS.BLUE}
                    >
                      Enviar Proposta
                    </ButtonStyled>
                    {isAdmin && (
                      <ButtonStyled
                        margin={'0 8px 0 0'}
                        onClick={() => setOpenPlusTime(true)}
                        variant="contained"
                        component="span"
                        bg={COLORS.GREEN_LIGHT}
                      >
                        Aumentar Validade
                      </ButtonStyled>
                    )}
                    <ButtonStyled
                      onClick={() => setOpenDeleteReservation(true)}
                      variant="contained"
                      component="span"
                      bg={COLORS.RED}
                    >
                      Excluir Reserva
                    </ButtonStyled>
                  </>
                )
              ) : (
                isAdmin && (
                  <ButtonStyled
                    onClick={() => setOpenDeleteReservation(true)}
                    variant="contained"
                    component="span"
                    bg={COLORS.RED}
                  >
                    Excluir Reserva
                  </ButtonStyled>
                )
              )}
            </Spacing>
          </>
        )}
      </ModalStyled>
    </>
  );
};

export default ModalReservation;
